module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Components")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Actionsheet_COM")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Alert_COM")]), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('p', [_vm._v("This component can be imported as plugin:")]), _vm._v(" "), _c('p', {
    staticClass: "warning"
  }, [_vm._v("\nWhen importing it as plugin, the usage is different from it in `template`. Please use  `little camel-case`  such as `buttonText` instead of `button-text`.\n")]), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Badge_COM")]), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Blur_COM")]), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("ButtonTab_COM")]), _vm._v(" "), _vm._m(36), _vm._v(" "), _vm._m(37), _vm._v(" "), _vm._m(38), _vm._v(" "), _vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _vm._m(41), _vm._v(" "), _vm._m(42), _vm._v(" "), _vm._m(43), _vm._v(" "), _vm._m(44), _vm._v(" "), _vm._m(45), _vm._v(" "), _vm._m(46), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Calendar_COM")]), _vm._v(" "), _vm._m(47), _vm._v(" "), _vm._m(48), _vm._v(" "), _vm._m(49), _vm._v(" "), _vm._m(50), _vm._v(" "), _vm._m(51), _vm._v(" "), _vm._m(52), _vm._v(" "), _vm._m(53), _vm._v(" "), _vm._m(54), _vm._v(" "), _vm._m(55), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Card_COM")]), _vm._v(" "), _vm._m(56), _vm._v(" "), _vm._m(57), _vm._v(" "), _vm._m(58), _vm._v(" "), _vm._m(59), _vm._v(" "), _vm._m(60), _vm._v(" "), _vm._m(61), _vm._v(" "), _vm._m(62), _vm._v(" "), _vm._m(63), _vm._v(" "), _vm._m(64), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("CellBox_COM")]), _vm._v(" "), _vm._m(65), _vm._v(" "), _vm._m(66), _vm._v(" "), _vm._m(67), _vm._v(" "), _vm._m(68), _vm._v(" "), _vm._m(69), _vm._v(" "), _vm._m(70), _vm._v(" "), _vm._m(71), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("CellFormPreview_COM")]), _vm._v(" "), _vm._m(72), _vm._v(" "), _vm._m(73), _vm._v(" "), _vm._m(74), _vm._v(" "), _vm._m(75), _vm._v(" "), _vm._m(76), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Cell_COM")]), _vm._v(" "), _vm._m(77), _vm._v(" "), _vm._m(78), _vm._v(" "), _vm._m(79), _vm._v(" "), _vm._m(80), _vm._v(" "), _vm._m(81), _vm._v(" "), _vm._m(82), _vm._v(" "), _vm._m(83), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("CheckIcon_COM")]), _vm._v(" "), _vm._m(84), _vm._v(" "), _vm._m(85), _vm._v(" "), _vm._m(86), _vm._v(" "), _vm._m(87), _vm._v(" "), _vm._m(88), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Checker_COM")]), _vm._v(" "), _vm._m(89), _vm._v(" "), _vm._m(90), _vm._v(" "), _vm._m(91), _vm._v(" "), _vm._m(92), _vm._v(" "), _vm._m(93), _vm._v(" "), _vm._m(94), _vm._v(" "), _vm._m(95), _vm._v(" "), _vm._m(96), _vm._v(" "), _vm._m(97), _vm._v(" "), _vm._m(98), _vm._v(" "), _vm._m(99), _vm._v(" "), _vm._m(100), _vm._v(" "), _vm._m(101), _vm._v(" "), _vm._m(102), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Checklist_COM")]), _vm._v(" "), _vm._m(103), _vm._v(" "), _vm._m(104), _vm._v(" "), _vm._m(105), _vm._v(" "), _vm._m(106), _vm._v(" "), _vm._m(107), _vm._v(" "), _vm._m(108), _vm._v(" "), _vm._m(109), _vm._v(" "), _vm._m(110), _vm._v(" "), _vm._m(111), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Clocker_COM")]), _vm._v(" "), _vm._m(112), _vm._v(" "), _vm._m(113), _vm._v(" "), _vm._m(114), _vm._v(" "), _vm._m(115), _vm._v(" "), _vm._m(116), _vm._v(" "), _vm._m(117), _vm._v(" "), _vm._m(118), _vm._v(" "), _vm._m(119), _vm._v(" "), _vm._m(120), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("ColorPicker_COM")]), _vm._v(" "), _vm._m(121), _vm._v(" "), _c('p', {
    staticClass: "warning"
  }, [_vm._v("This Component is Deprecated. use cell and slot instead")]), _vm._v(" "), _vm._m(122), _vm._v(" "), _vm._m(123), _vm._v(" "), _vm._m(124), _vm._v(" "), _vm._m(125), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Confirm_COM")]), _vm._v(" "), _vm._m(126), _vm._v(" "), _vm._m(127), _vm._v(" "), _vm._m(128), _vm._v(" "), _vm._m(129), _vm._v(" "), _vm._m(130), _vm._v(" "), _vm._m(131), _vm._v(" "), _vm._m(132), _vm._v(" "), _vm._m(133), _vm._v(" "), _vm._m(134), _vm._v(" "), _vm._m(135), _vm._v(" "), _vm._m(136), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Countdown_COM")]), _vm._v(" "), _vm._m(137), _vm._v(" "), _c('p', {
    staticClass: "warning"
  }, [_vm._v("This Component is Deprecated. ")]), _vm._v(" "), _vm._m(138), _vm._v(" "), _vm._m(139), _vm._v(" "), _vm._m(140), _vm._v(" "), _vm._m(141), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Countup_COM")]), _vm._v(" "), _vm._m(142), _vm._v(" "), _vm._m(143), _vm._v(" "), _vm._m(144), _vm._v(" "), _vm._m(145), _vm._v(" "), _vm._m(146), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("DatetimeRange_COM")]), _vm._v(" "), _vm._m(147), _vm._v(" "), _vm._m(148), _vm._v(" "), _vm._m(149), _vm._v(" "), _vm._m(150), _vm._v(" "), _vm._m(151), _vm._v(" "), _vm._m(152), _vm._v(" "), _vm._m(153), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("DatetimeView_COM")]), _vm._v(" "), _vm._m(154), _vm._v(" "), _vm._m(155), _vm._v(" "), _vm._m(156), _vm._v(" "), _vm._m(157), _vm._v(" "), _vm._m(158), _vm._v(" "), _vm._m(159), _vm._v(" "), _vm._m(160), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Datetime_COM")]), _vm._v(" "), _vm._m(161), _vm._v(" "), _vm._m(162), _vm._v(" "), _vm._m(163), _vm._v(" "), _vm._m(164), _vm._v(" "), _vm._m(165), _vm._v(" "), _vm._m(166), _vm._v(" "), _vm._m(167), _vm._v(" "), _vm._m(168), _vm._v(" "), _vm._m(169), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Divider_COM")]), _vm._v(" "), _vm._m(170), _vm._v(" "), _vm._m(171), _vm._v(" "), _vm._m(172), _vm._v(" "), _vm._m(173), _vm._v(" "), _vm._m(174), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Drawer_COM")]), _vm._v(" "), _vm._m(175), _vm._v(" "), _vm._m(176), _vm._v(" "), _c('p', [_vm._v("this component is forked from: https://github.com/bajian/vue-drawer")]), _vm._v(" "), _vm._m(177), _vm._v(" "), _vm._m(178), _vm._v(" "), _vm._m(179), _vm._v(" "), _vm._m(180), _vm._v(" "), _vm._m(181), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Flexbox_COM")]), _vm._v(" "), _vm._m(182), _vm._v(" "), _vm._m(183), _vm._v(" "), _vm._m(184), _vm._v(" "), _vm._m(185), _vm._v(" "), _vm._m(186), _vm._v(" "), _vm._m(187), _vm._v(" "), _vm._m(188), _vm._v(" "), _vm._m(189), _vm._v(" "), _vm._m(190), _vm._v(" "), _vm._m(191), _vm._v(" "), _vm._m(192), _vm._v(" "), _vm._m(193), _vm._v(" "), _vm._m(194), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Flow_COM")]), _vm._v(" "), _vm._m(195), _vm._v(" "), _vm._m(196), _vm._v(" "), _vm._m(197), _vm._v(" "), _vm._m(198), _vm._v(" "), _vm._m(199), _vm._v(" "), _vm._m(200), _vm._v(" "), _vm._m(201), _vm._v(" "), _vm._m(202), _vm._v(" "), _vm._m(203), _vm._v(" "), _vm._m(204), _vm._v(" "), _vm._m(205), _vm._v(" "), _vm._m(206), _vm._v(" "), _vm._m(207), _vm._v(" "), _vm._m(208), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("FormPreview_COM")]), _vm._v(" "), _vm._m(209), _vm._v(" "), _vm._m(210), _vm._v(" "), _vm._m(211), _vm._v(" "), _vm._m(212), _vm._v(" "), _vm._m(213), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Grid_COM")]), _vm._v(" "), _vm._m(214), _vm._v(" "), _vm._m(215), _vm._v(" "), _vm._m(216), _vm._v(" "), _vm._m(217), _vm._v(" "), _vm._m(218), _vm._v(" "), _vm._m(219), _vm._v(" "), _vm._m(220), _vm._v(" "), _vm._m(221), _vm._v(" "), _vm._m(222), _vm._v(" "), _vm._m(223), _vm._v(" "), _vm._m(224), _vm._v(" "), _vm._m(225), _vm._v(" "), _vm._m(226), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Group_COM")]), _vm._v(" "), _vm._m(227), _vm._v(" "), _vm._m(228), _vm._v(" "), _vm._m(229), _vm._v(" "), _vm._m(230), _vm._v(" "), _vm._m(231), _vm._v(" "), _vm._m(232), _vm._v(" "), _vm._m(233), _vm._v(" "), _vm._m(234), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Icon_COM")]), _vm._v(" "), _vm._m(235), _vm._v(" "), _vm._m(236), _vm._v(" "), _vm._m(237), _vm._v(" "), _vm._m(238), _vm._v(" "), _vm._m(239), _vm._v(" "), _vm._m(240), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("InlineCalendar_COM")]), _vm._v(" "), _vm._m(241), _vm._v(" "), _vm._m(242), _vm._v(" "), _vm._m(243), _vm._v(" "), _vm._m(244), _vm._v(" "), _vm._m(245), _vm._v(" "), _vm._m(246), _vm._v(" "), _vm._m(247), _vm._v(" "), _vm._m(248), _vm._v(" "), _vm._m(249), _vm._v(" "), _vm._m(250), _vm._v(" "), _vm._m(251), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("InlineLoading_COM")]), _vm._v(" "), _vm._m(252), _vm._v(" "), _vm._m(253), _vm._v(" "), _c('p', [_vm._v("require vux@^2.3.4")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("InlineXNumber_COM")]), _vm._v(" "), _vm._m(254), _vm._v(" "), _vm._m(255), _vm._v(" "), _vm._m(256), _vm._v(" "), _vm._m(257), _vm._v(" "), _vm._m(258), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("LoadMore_COM")]), _vm._v(" "), _vm._m(259), _vm._v(" "), _vm._m(260), _vm._v(" "), _vm._m(261), _vm._v(" "), _vm._m(262), _vm._v(" "), _vm._m(263), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Loading_COM")]), _vm._v(" "), _vm._m(264), _vm._v(" "), _vm._m(265), _vm._v(" "), _vm._m(266), _vm._v(" "), _vm._m(267), _vm._v(" "), _vm._m(268), _vm._v(" "), _vm._m(269), _vm._v(" "), _vm._m(270), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Marquee_COM")]), _vm._v(" "), _vm._m(271), _vm._v(" "), _vm._m(272), _vm._v(" "), _vm._m(273), _vm._v(" "), _vm._m(274), _vm._v(" "), _vm._m(275), _vm._v(" "), _vm._m(276), _vm._v(" "), _vm._m(277), _vm._v(" "), _vm._m(278), _vm._v(" "), _vm._m(279), _vm._v(" "), _vm._m(280), _vm._v(" "), _vm._m(281), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Masker_COM")]), _vm._v(" "), _vm._m(282), _vm._v(" "), _vm._m(283), _vm._v(" "), _vm._m(284), _vm._v(" "), _vm._m(285), _vm._v(" "), _vm._m(286), _vm._v(" "), _vm._m(287), _vm._v(" "), _vm._m(288), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Msg_COM")]), _vm._v(" "), _vm._m(289), _vm._v(" "), _vm._m(290), _vm._v(" "), _vm._m(291), _vm._v(" "), _vm._m(292), _vm._v(" "), _vm._m(293), _vm._v(" "), _vm._m(294), _vm._v(" "), _vm._m(295), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Panel_COM")]), _vm._v(" "), _vm._m(296), _vm._v(" "), _vm._m(297), _vm._v(" "), _vm._m(298), _vm._v(" "), _vm._m(299), _vm._v(" "), _vm._m(300), _vm._v(" "), _vm._m(301), _vm._v(" "), _vm._m(302), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Picker_COM")]), _vm._v(" "), _vm._m(303), _vm._v(" "), _vm._m(304), _vm._v(" "), _vm._m(305), _vm._v(" "), _vm._m(306), _vm._v(" "), _vm._m(307), _vm._v(" "), _vm._m(308), _vm._v(" "), _vm._m(309), _vm._v(" "), _vm._m(310), _vm._v(" "), _vm._m(311), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Popover_COM")]), _vm._v(" "), _vm._m(312), _vm._v(" "), _vm._m(313), _vm._v(" "), _vm._m(314), _vm._v(" "), _vm._m(315), _vm._v(" "), _vm._m(316), _vm._v(" "), _vm._m(317), _vm._v(" "), _vm._m(318), _vm._v(" "), _vm._m(319), _vm._v(" "), _vm._m(320), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("PopupHeader_COM")]), _vm._v(" "), _vm._m(321), _vm._v(" "), _vm._m(322), _vm._v(" "), _vm._m(323), _vm._v(" "), _vm._m(324), _vm._v(" "), _vm._m(325), _vm._v(" "), _vm._m(326), _vm._v(" "), _vm._m(327), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("PopupPicker_COM")]), _vm._v(" "), _vm._m(328), _vm._v(" "), _vm._m(329), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("\n  other props are the same as `Picker`\n")]), _vm._v(" "), _vm._m(330), _vm._v(" "), _vm._m(331), _vm._v(" "), _vm._m(332), _vm._v(" "), _vm._m(333), _vm._v(" "), _vm._m(334), _vm._v(" "), _vm._m(335), _vm._v(" "), _vm._m(336), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("PopupRadio_COM")]), _vm._v(" "), _vm._m(337), _vm._v(" "), _vm._m(338), _vm._v(" "), _c('p', [_vm._v("props are the same as cell’s and radio’s. Be aware that it doesnot support fillMode.")]), _vm._v(" "), _vm._m(339), _vm._v(" "), _vm._m(340), _vm._v(" "), _vm._m(341), _vm._v(" "), _vm._m(342), _vm._v(" "), _vm._m(343), _vm._v(" "), _vm._m(344), _vm._v(" "), _vm._m(345), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Popup_COM")]), _vm._v(" "), _vm._m(346), _vm._v(" "), _vm._m(347), _vm._v(" "), _vm._m(348), _vm._v(" "), _vm._m(349), _vm._v(" "), _vm._m(350), _vm._v(" "), _vm._m(351), _vm._v(" "), _vm._m(352), _vm._v(" "), _vm._m(353), _vm._v(" "), _vm._m(354), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Previewer_COM")]), _vm._v(" "), _vm._m(355), _vm._v(" "), _vm._m(356), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("please avoid using large pictures or they may crash your browser(especially on Android).")])]), _vm._v(" "), _c('p', [_vm._v("example for list:")]), _vm._v(" "), _vm._m(357), _vm._v(" "), _c('p', {
    staticClass: "warning"
  }, [_vm._v("before v2.4.0, `w` and `h` should be specified.")]), _vm._v(" "), _c('p', [_vm._v("Prevewing an image by index:")]), _vm._v(" "), _vm._m(358), _vm._v(" "), _vm._m(359), _vm._v(" "), _vm._m(360), _vm._v(" "), _vm._m(361), _vm._v(" "), _vm._m(362), _vm._v(" "), _vm._m(363), _vm._v(" "), _vm._m(364), _vm._v(" "), _vm._m(365), _vm._v(" "), _vm._m(366), _vm._v(" "), _vm._m(367), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Qrcode_COM")]), _vm._v(" "), _vm._m(368), _vm._v(" "), _vm._m(369), _vm._v(" "), _vm._m(370), _vm._v(" "), _vm._m(371), _vm._v(" "), _vm._m(372), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Radio_COM")]), _vm._v(" "), _vm._m(373), _vm._v(" "), _vm._m(374), _vm._v(" "), _vm._m(375), _vm._v(" "), _vm._m(376), _vm._v(" "), _vm._m(377), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("`radio` should be used in `Group`.")]), _vm._v(" "), _vm._m(378), _vm._v(" "), _vm._m(379), _vm._v(" "), _vm._m(380), _vm._v(" "), _vm._m(381), _vm._v(" "), _vm._m(382), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Range_COM")]), _vm._v(" "), _vm._m(383), _vm._v(" "), _vm._m(384), _vm._v(" "), _vm._m(385), _vm._v(" "), _vm._m(386), _vm._v(" "), _vm._m(387), _vm._v(" "), _vm._m(388), _vm._v(" "), _vm._m(389), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Rater_COM")]), _vm._v(" "), _vm._m(390), _vm._v(" "), _vm._m(391), _vm._v(" "), _vm._m(392), _vm._v(" "), _vm._m(393), _vm._v(" "), _vm._m(394), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Scroller_COM")]), _vm._v(" "), _vm._m(395), _vm._v(" "), _vm._m(396), _vm._v(" "), _vm._m(397), _vm._v(" "), _vm._m(398), _vm._v(" "), _vm._m(399), _vm._v(" "), _vm._m(400), _vm._v(" "), _vm._m(401), _vm._v(" "), _vm._m(402), _vm._v(" "), _vm._m(403), _vm._v(" "), _vm._m(404), _vm._v(" "), _vm._m(405), _vm._v(" "), _c('p', [_vm._v("pulldown 默认配置:")]), _vm._v(" "), _vm._m(406), _vm._v(" "), _c('p', [_vm._v("pullup 默认配置:")]), _vm._v(" "), _vm._m(407), _vm._v(" "), _vm._m(408), _vm._v(" "), _vm._m(409), _vm._v(" "), _vm._m(410), _vm._v(" "), _c('p', [_vm._v("如果展示内容完全重载，那么需要主动设置位置让其能正确回到顶部。适用于改变筛选条件后重载数据的情况")]), _vm._v(" "), _vm._m(411), _vm._v(" "), _vm._m(412), _vm._v(" "), _vm._m(413), _vm._v(" "), _vm._m(414), _vm._v(" "), _c('p', [_vm._v("方法2，绑定value, 重置状态")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("自定义pullup模板同样是用v-model来绑定以获取状态变化")]), _vm._v(" "), _vm._m(415), _vm._v(" "), _vm._m(416), _vm._v(" "), _vm._m(417), _vm._v(" "), _vm._m(418), _vm._v(" "), _vm._m(419), _vm._v(" "), _vm._m(420), _vm._v(" "), _vm._m(421), _vm._v(" "), _vm._m(422), _vm._v(" "), _vm._m(423), _vm._v(" "), _vm._m(424), _vm._v(" "), _vm._m(425), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Search_COM")]), _vm._v(" "), _vm._m(426), _vm._v(" "), _vm._m(427), _vm._v(" "), _vm._m(428), _vm._v(" "), _vm._m(429), _vm._v(" "), _vm._m(430), _vm._v(" "), _vm._m(431), _vm._v(" "), _vm._m(432), _vm._v(" "), _vm._m(433), _vm._v(" "), _vm._m(434), _vm._v(" "), _vm._m(435), _vm._v(" "), _vm._m(436), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Selector_COM")]), _vm._v(" "), _vm._m(437), _vm._v(" "), _vm._m(438), _vm._v(" "), _vm._m(439), _vm._v(" "), _vm._m(440), _vm._v(" "), _vm._m(441), _vm._v(" "), _vm._m(442), _vm._v(" "), _vm._m(443), _vm._v(" "), _vm._m(444), _vm._v(" "), _vm._m(445), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Spinner_COM")]), _vm._v(" "), _vm._m(446), _vm._v(" "), _vm._m(447), _vm._v(" "), _vm._m(448), _vm._v(" "), _vm._m(449), _vm._v(" "), _vm._m(450), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Step_COM")]), _vm._v(" "), _vm._m(451), _vm._v(" "), _vm._m(452), _vm._v(" "), _vm._m(453), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Sticky_COM")]), _vm._v(" "), _vm._m(454), _vm._v(" "), _vm._m(455), _vm._v(" "), _vm._m(456), _vm._v(" "), _vm._m(457), _vm._v(" "), _vm._m(458), _vm._v(" "), _vm._m(459), _vm._v(" "), _vm._m(460), _vm._v(" "), _vm._m(461), _vm._v(" "), _vm._m(462), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Swipeout_COM")]), _vm._v(" "), _vm._m(463), _vm._v(" "), _vm._m(464), _vm._v(" "), _c('p', [_vm._v("包装子组件的wrap组件")]), _vm._v(" "), _vm._m(465), _vm._v(" "), _vm._m(466), _vm._v(" "), _vm._m(467), _vm._v(" "), _vm._m(468), _vm._v(" "), _vm._m(469), _vm._v(" "), _vm._m(470), _vm._v(" "), _vm._m(471), _vm._v(" "), _vm._m(472), _vm._v(" "), _vm._m(473), _vm._v(" "), _vm._m(474), _vm._v(" "), _vm._m(475), _vm._v(" "), _vm._m(476), _vm._v(" "), _vm._m(477), _vm._v(" "), _vm._m(478), _vm._v(" "), _vm._m(479), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Swiper_COM")]), _vm._v(" "), _vm._m(480), _vm._v(" "), _vm._m(481), _vm._v(" "), _vm._m(482), _vm._v(" "), _vm._m(483), _vm._v(" "), _vm._m(484), _vm._v(" "), _vm._m(485), _vm._v(" "), _vm._m(486), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Tab_COM")]), _vm._v(" "), _vm._m(487), _vm._v(" "), _vm._m(488), _vm._v(" "), _vm._m(489), _vm._v(" "), _vm._m(490), _vm._v(" "), _vm._m(491), _vm._v(" "), _vm._m(492), _vm._v(" "), _vm._m(493), _vm._v(" "), _vm._m(494), _vm._v(" "), _vm._m(495), _vm._v(" "), _vm._m(496), _vm._v(" "), _vm._m(497), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Tabbar_COM")]), _vm._v(" "), _vm._m(498), _vm._v(" "), _vm._m(499), _vm._v(" "), _vm._m(500), _vm._v(" "), _vm._m(501), _vm._v(" "), _vm._m(502), _vm._v(" "), _vm._m(503), _vm._v(" "), _vm._m(504), _vm._v(" "), _vm._m(505), _vm._v(" "), _vm._m(506), _vm._v(" "), _vm._m(507), _vm._v(" "), _vm._m(508), _vm._v(" "), _vm._m(509), _vm._v(" "), _vm._m(510), _vm._v(" "), _vm._m(511), _vm._v(" "), _vm._m(512), _vm._v(" "), _vm._m(513), _vm._v(" "), _vm._m(514), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Timeline_COM")]), _vm._v(" "), _vm._m(515), _vm._v(" "), _vm._m(516), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Toast_COM")]), _vm._v(" "), _vm._m(517), _vm._v(" "), _vm._m(518), _vm._v(" "), _vm._m(519), _vm._v(" "), _vm._m(520), _vm._v(" "), _vm._m(521), _vm._v(" "), _vm._m(522), _vm._v(" "), _vm._m(523), _vm._v(" "), _vm._m(524), _vm._v(" "), _vm._m(525), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("ViewBox_COM")]), _vm._v(" "), _vm._m(526), _vm._v(" "), _vm._m(527), _vm._v(" "), _vm._m(528), _vm._v(" "), _vm._m(529), _vm._v(" "), _vm._m(530), _vm._v(" "), _vm._m(531), _vm._v(" "), _vm._m(532), _vm._v(" "), _vm._m(533), _vm._v(" "), _vm._m(534), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("WechatEmotion_COM")]), _vm._v(" "), _vm._m(535), _vm._v(" "), _vm._m(536), _vm._v(" "), _vm._m(537), _vm._v(" "), _vm._m(538), _vm._v(" "), _vm._m(539), _vm._v(" "), _vm._m(540), _vm._v(" "), _vm._m(541), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("XAddress_COM")]), _vm._v(" "), _vm._m(542), _vm._v(" "), _vm._m(543), _vm._v(" "), _vm._m(544), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("\nyou can view source data at [src/datas](https://github.com/airyland/vux/tree/v2/src/datas).\n")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("`x-address` should be used in `Group`")]), _vm._v(" "), _vm._m(545), _vm._v(" "), _vm._m(546), _vm._v(" "), _vm._m(547), _vm._v(" "), _vm._m(548), _vm._v(" "), _vm._m(549), _vm._v(" "), _vm._m(550), _vm._v(" "), _vm._m(551), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("XButton_COM")]), _vm._v(" "), _vm._m(552), _vm._v(" "), _vm._m(553), _vm._v(" "), _vm._m(554), _vm._v(" "), _vm._m(555), _vm._v(" "), _vm._m(556), _vm._v(" "), _vm._m(557), _vm._v(" "), _vm._m(558), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("XCircle_COM")]), _vm._v(" "), _vm._m(559), _vm._v(" "), _vm._m(560), _vm._v(" "), _vm._m(561), _vm._v(" "), _vm._m(562), _vm._v(" "), _vm._m(563), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("XDialog_COM")]), _vm._v(" "), _vm._m(564), _vm._v(" "), _vm._m(565), _vm._v(" "), _vm._m(566), _vm._v(" "), _vm._m(567), _vm._v(" "), _vm._m(568), _vm._v(" "), _vm._m(569), _vm._v(" "), _vm._m(570), _vm._v(" "), _vm._m(571), _vm._v(" "), _vm._m(572), _vm._v(" "), _vm._m(573), _vm._v(" "), _vm._m(574), _vm._v(" "), _vm._m(575), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("XHeader_COM")]), _vm._v(" "), _vm._m(576), _vm._v(" "), _vm._m(577), _vm._v(" "), _vm._m(578), _vm._v(" "), _vm._m(579), _vm._v(" "), _vm._m(580), _vm._v(" "), _vm._m(581), _vm._v(" "), _vm._m(582), _vm._v(" "), _vm._m(583), _vm._v(" "), _vm._m(584), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("XIcon_COM")]), _vm._v(" "), _vm._m(585), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("\nIcons come from [Ionicons(MIT)](http://ionicons.com/)\n")]), _vm._v(" "), _vm._m(586), _vm._v(" "), _vm._m(587), _vm._v(" "), _vm._m(588), _vm._v(" "), _vm._m(589), _vm._v(" "), _vm._m(590), _vm._v(" "), _vm._m(591), _vm._v(" "), _vm._m(592), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("XImg_COM")]), _vm._v(" "), _vm._m(593), _vm._v(" "), _vm._m(594), _vm._v(" "), _vm._m(595), _vm._v(" "), _vm._m(596), _vm._v(" "), _vm._m(597), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("XInput_COM")]), _vm._v(" "), _vm._m(598), _vm._v(" "), _vm._m(599), _vm._v(" "), _vm._m(600), _vm._v(" "), _vm._m(601), _vm._v(" "), _vm._m(602), _vm._v(" "), _vm._m(603), _vm._v(" "), _vm._m(604), _vm._v(" "), _vm._m(605), _vm._v(" "), _vm._m(606), _vm._v(" "), _vm._m(607), _vm._v(" "), _vm._m(608), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("XNumber_COM")]), _vm._v(" "), _vm._m(609), _vm._v(" "), _vm._m(610), _vm._v(" "), _vm._m(611), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("`x-number` shoule be used in `Group`")]), _vm._v(" "), _vm._m(612), _vm._v(" "), _vm._m(613), _vm._v(" "), _vm._m(614), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("XProgress_COM")]), _vm._v(" "), _vm._m(615), _vm._v(" "), _vm._m(616), _vm._v(" "), _vm._m(617), _vm._v(" "), _vm._m(618), _vm._v(" "), _vm._m(619), _vm._v(" "), _vm._m(620), _vm._v(" "), _vm._m(621), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("XSwitch_COM")]), _vm._v(" "), _vm._m(622), _vm._v(" "), _vm._m(623), _vm._v(" "), _vm._m(624), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("`x-switch` should be used in `Group`.")]), _vm._v(" "), _vm._m(625), _vm._v(" "), _vm._m(626), _vm._v(" "), _vm._m(627), _vm._v(" "), _vm._m(628), _vm._v(" "), _vm._m(629), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("XTable_COM")]), _vm._v(" "), _vm._m(630), _vm._v(" "), _vm._m(631), _vm._v(" "), _vm._m(632), _vm._v(" "), _vm._m(633), _vm._v(" "), _vm._m(634), _vm._v(" "), _vm._m(635), _vm._v(" "), _vm._m(636), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("XTextarea_COM")]), _vm._v(" "), _vm._m(637), _vm._v(" "), _vm._m(638), _vm._v(" "), _vm._m(639), _vm._v(" "), _vm._m(640), _vm._v(" "), _vm._m(641), _vm._v(" "), _vm._m(642), _vm._v(" "), _vm._m(643), _vm._v(" "), _vm._m(644), _vm._v(" "), _vm._m(645), _vm._v(" "), _vm._m(646), _vm._v(" "), _vm._m(647)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/actionsheet/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/actionsheet"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/actionsheet",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Actionsheet.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Actionsheet } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if showing the component; use v-model for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-cancel")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if showing the cancel menu; invalid for android theme")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("cancel-text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("cancel(取消)")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("text of cancel menu")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("theme")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("ios")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("theme of menus, can be in [‘ios’, ‘android’]")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("menus")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")]), _c('br'), _c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td', [_vm._v("{}")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("menu items, for example: "), _c('code', [_vm._v("{menu1: 'some text'}")]), _vm._v(", menu name with "), _c('code', [_vm._v(".noop")]), _vm._v(" will not trigger click events. "), _c('br'), _c('code', [_vm._v("Menus")]), _vm._v(" supports array since "), _c('code', [_vm._v("v2.1.0")]), _vm._v(". Keys can be customized. More details below.")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("close-on-clicking-mask")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.0.0")])]), _vm._v(" "), _c('td', [_vm._v("if closing actionsheet when clicking on mask")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("close-on-clicking-menu")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.8")])]), _vm._v(" "), _c('td', [_vm._v("if hide automatically when clicking on menus")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click-menu")])]), _vm._v(" "), _c('td', [_vm._v("(menuKey, menuItem)")]), _vm._v(" "), _c('td', [_vm._v("triggers when clicking on the menu")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click-menu-{menuKey}")])]), _vm._v(" "), _c('td', [_vm._v("(menuKey)")]), _vm._v(" "), _c('td', [_vm._v("shortcut event for easier listening, "), _c('code', [_vm._v("menuKey")]), _vm._v(" is related to "), _c('code', [_vm._v("label")]), _vm._v(". For exapmple, you can listen on "), _c('code', [_vm._v("on-click-menu-delete")]), _vm._v(" if you have a menu named "), _c('code', [_vm._v("delete")])]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click-menu-cancel")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("triggers when clicking on the cancel menu")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click-mask")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("triggers when clicking on mask")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.4")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/actionsheet"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("From "), _c('code', [_vm._v("v2.1.0")]), _vm._v(", "), _c('code', [_vm._v("menus")]), _vm._v(" supports type: Array.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('code', [_vm._v("label")]), _vm._v(": label name，you can use simple text or "), _c('code', [_vm._v("html")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('code', [_vm._v("value")]), _vm._v(": event name，if not specified, no "), _c('code', [_vm._v("on-click-menu")]), _vm._v(" will be emitted")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('code', [_vm._v("type")]), _vm._v(":")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('code', [_vm._v("primary")]), _vm._v(" primary color")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("warn")]), _vm._v(" warn color")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("disabled")]), _vm._v(" gray color, the menu cannot be clicked")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("info")]), _vm._v(" the menu item shows as a tip, the same function as "), _c('code', [_vm._v("key.noop")]), _vm._v(" when setting menus by "), _c('code', [_vm._v("Object")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("[{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Are you sure?<br/><span style=\"color:#666;font-size:12px;\">Once deleted, you will never find it.</span>'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'info'")]), _vm._v("\n}, {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Primary'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'primary'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("value")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'primary'")]), _vm._v("\n}, {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Warn'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'warn'")]), _vm._v("\n}, {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Disabled'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'disabled'")]), _vm._v("\n}, {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Default'")]), _vm._v("\n}]\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/alert/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/alert"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/alert",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Alert.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Alert } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v("  { AlertPlugin } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\nVue.use(AlertPlugin)\n\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// or the way of umd")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// import built js file")]), _vm._v("\nVue.use(vuxAlertPlugin)\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// show")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$vux.alert.show({\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("title")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Vux is Cool'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("content")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Do you agree?'")]), _vm._v(",\n  onShow () {\n    "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("console")]), _vm._v(".log("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Plugin: I\\'m showing'")]), _vm._v(")\n  },\n  onHide () {\n    "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("console")]), _vm._v(".log("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Plugin: I\\'m hiding'")]), _vm._v(")\n  }\n})\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// hide")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$vux.alert.hide()\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("visibility of the component, use v-model for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("title")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("content")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.0")])]), _vm._v(" "), _c('td', [_vm._v("alert content, and will be replaced if using slot:default")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("button-text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("ok(确定)")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("button text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("hide-on-blur")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if closing dialog when clicking on mask")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("mask-transition")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("vux-fade")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("mask transition")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("dialog-transition")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("vux-dialog")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("dialog transition")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("mask-z-index")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")]), _c('br'), _c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("1000")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.4")])]), _vm._v(" "), _c('td', [_vm._v("zIndex of mask")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("dialog content")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-show")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when dialog shows")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-hide")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when dialog is closed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/alert"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/badge/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/badge"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/badge",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Badge.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Badge } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("text of the Badge")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/badge"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/blur/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/blur"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/blur",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Blur.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Blur } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("blur-amount")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("10")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("blur amount of the effect")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("url")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("url of the image")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("height")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("200")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("height of the container")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("content of the container, above the blur image")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/blur"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/button-tab/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/button-tab"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/button-tab",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/ButtonTab.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { ButtonTab, ButtonTabItem } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-component-name"
  }, [_vm._v("ButtonTab")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("current index, start from 0, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("height")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("30")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("height in px")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-component-name"
  }, [_vm._v("ButtonTabItem")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("selected")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if selected")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-item-click")])]), _vm._v(" "), _c('td', [_vm._v("(index)")]), _vm._v(" "), _c('td', [_vm._v("emits when item is clicked")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/button-tab"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/calendar/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/calendar"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/calendar",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Calendar.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Calendar } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("calendar")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("title")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"title\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-model")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"value\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("calendar")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group")]), _vm._v(">")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tip"
  }, [_vm._v("`calendar` can be only used in `Group`\n"), _c('br'), _vm._v("\nExcept `title` and `value`, other `props` are the same as those of `inline-calendar`.\n")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("form value, binding by v-model. Empty means single seleciton; [] means multiple selection. When the value is “TODAY”, can quick pick current date. "), _c('code', [_vm._v("placeholder")]), _vm._v(" is valid only when the value is empty or [].")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("text of label")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("placeholder")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("placeholder")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-popup-header")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.0")])]), _vm._v(" "), _c('td', [_vm._v("whether show popup header. Show under multiple selection mode; hide under single selection mode.")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("popup-header-title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.0")])]), _vm._v(" "), _c('td', [_vm._v("popup header title")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("display-format")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-function"
  }, [_vm._v("Function")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.4")])]), _vm._v(" "), _c('td', [_vm._v("format value before displaying in cell")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("readonly")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.7.2")])]), _vm._v(" "), _c('td', [_vm._v("whether disable selecting")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td', [_vm._v("(value)")]), _vm._v(" "), _c('td', [_vm._v("emits when value changes")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-show")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when popup shows")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-hide")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when popup hides")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/calendar"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/card/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/card"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/card",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Card.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Card } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("header.title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("title of header, not show without specify content")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("footer.title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("title of footer, not show without specify content")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("footer.link")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("link in the bottom, normal url or a v-link argument")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("header")])]), _vm._v(" "), _c('td', [_vm._v("header")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("content")])]), _vm._v(" "), _c('td', [_vm._v("content, the main body part")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("footer")])]), _vm._v(" "), _c('td', [_vm._v("footer")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click-footer")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when clicking the footer")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click-header")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when clicking the header")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/card"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/cell-box/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/cell-box"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/cell-box",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/CellBox.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { CellBox } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("is-link")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if this is a link; if true, there will be an arrow on the right")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("link")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")]), _c('br'), _c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("redirect link. Can be http(s) protocol; can also be vue-router format")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("border-intent")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.1")])]), _vm._v(" "), _c('td', [_vm._v("if set border intent on the left side")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("align-items")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("center")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.5")])]), _vm._v(" "), _c('td', [_vm._v("flexbox align-items setting")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("content body")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/cell-box"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/cell-form-preview/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/cell-form-preview"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/cell-form-preview",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/CellFormPreview.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { CellFormPreview } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("list")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.0")])]), _vm._v(" "), _c('td', [_vm._v("label and value list")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("border-intent")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.1")])]), _vm._v(" "), _c('td', [_vm._v("if set border intent on the left side")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/cell-form-preview"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/cell/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/cell"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/cell",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Cell.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Cell } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("label text on the left")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("right text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("inline-desc")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("the text below title")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("link")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")]), _c('br'), _c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("redirect link. Can be http(s) protocol; can also be vue-router format")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("is-link")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if this is a link; if true, there will be an arrow on the right")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("primary")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("title")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("main content area, can be in [‘title’, ‘content’]")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("is-loading")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.0")])]), _vm._v(" "), _c('td', [_vm._v("if show loading icon, good for asynchronous loading")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value-align")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("left")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.0")])]), _vm._v(" "), _c('td', [_vm._v("value’s text-align，one of left, right. prop:primary will be set to content if value-align value is right")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("border-intent")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.1")])]), _vm._v(" "), _c('td', [_vm._v("if set border intent on the left side")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("arrow-direction")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.1")])]), _vm._v(" "), _c('td', [_vm._v("arrow direction, one of up, down")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.2")])]), _vm._v(" "), _c('td', [_vm._v("set disabled style for label and arrow (if is-link is true)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("align-items")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("center")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.4")])]), _vm._v(" "), _c('td', [_vm._v("align-items value")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("right area, you can use default slot instead of prop:value so you can use complicated layout")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_vm._v("[deprecated] the same as default slot")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("icon")])]), _vm._v(" "), _c('td', [_vm._v("icon area before title")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("after-title")])]), _vm._v(" "), _c('td', [_vm._v("after title")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("child")])]), _vm._v(" "), _c('td', [_vm._v("the child element of the cell, you can add an element with absolute position")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("inline-desc")])]), _vm._v(" "), _c('td', [_vm._v("inline-desc slot, the same function as prop:inline-desc but can use html")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.6")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_vm._v("title slot")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.3")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/cell"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/check-icon/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/check-icon"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/check-icon",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/CheckIcon.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { CheckIcon } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.8")])]), _vm._v(" "), _c('td', [_vm._v("if selected, use :value.sync for two-way data binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("type")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("unknown")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("style of check icon, can be [‘plain’]")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/check-icon"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/checker/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/checker"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/checker",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Checker.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Checker } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('code', [_vm._v("Checker")]), _vm._v(" is a more flexible component than "), _c('code', [_vm._v("Radio")]), _vm._v(" and "), _c('code', [_vm._v("Checklist")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-component-name"
  }, [_vm._v("Checker")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default-item-class")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("default checker-item classname")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("selected-item-class")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("selected check-item classname")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled-item-class")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("disabled check-item classname")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("type")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("radio")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("checker type, should be raido or checkbox")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")]), _c('br'), _c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("selected value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("max")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("max selected number when type = checkbox")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("radio-required")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.3")])]), _vm._v(" "), _c('td', [_vm._v("whether value is required in radio mode. if true, current selected item will always be selected even after clicking")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value)")])]), _vm._v(" "), _c('td', [_vm._v("emits when value is changed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-component-name"
  }, [_vm._v("CheckerItem")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("value of current checker-item")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if current item is disabled")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-item-click")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(itemValue, itemDisabled)")])]), _vm._v(" "), _c('td', [_vm._v("emits when current checker-item is clicked")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/checker"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/checklist/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/checklist"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/checklist",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Checklist.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Checklist } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("form value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("title")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("required")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if required")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("options")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("options list")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("max")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("max selected number")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("min")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("min selected number")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("random-order")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if place options in a random order")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("check-disabled")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.1")])]), _vm._v(" "), _c('td', [_vm._v("if disabled item when selectedItems.length === total.length, by using this prop:max no longer works")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("label-position")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("right")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.4")])]), _vm._v(" "), _c('td', [_vm._v("label position, can be set to left or right")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.8")])]), _vm._v(" "), _c('td', [_vm._v("if disable user from selecting")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td', [_vm._v("(value, label)")]), _vm._v(" "), _c('td', [_vm._v("emits when value changes, param:label is supported after v2.5.7")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("getFullValue")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("get current value with label")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.4")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/checklist"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/clocker/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/clocker"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/clocker",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Clocker.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Clocker } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("time")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("the end time")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("format")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("%D 天 %H 小时 %M 分 %S 秒")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("the result format")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("if specified, will be the format for the result")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-tick")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("triggers on time ticking")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-finish")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("triggers on time end")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/clocker"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/color-picker/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/color-picker"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/color-picker",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/ColorPicker.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { ColorPicker } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("form value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("colors")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("color list")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("size")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("large")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("button size, enum: large, middle, small")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/color-picker"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/confirm/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/confirm"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/confirm",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Confirm.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Confirm } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("visibility of the component")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-input")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.0")])]), _vm._v(" "), _c('td', [_vm._v("whether show input or not. If true, slot will not work")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("placeholder")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.0")])]), _vm._v(" "), _c('td', [_vm._v("placeholder of prompt, valid when show-input is true")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("theme")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("ios")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("dialog’s style, can be ios or android")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("hide-on-blur")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if closing dialog when clicking on mask")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("dialog title")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("content")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("dialog content, can use html. Invalid when using slot")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("confirm-text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("确认(confirm)")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("text of confirm button")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("cancel-text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("取消(cancel)")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("text of cancel button")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("mask-transition")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("vux-fade")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("mask’s transition")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("dialog-transition")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("vux-dialog")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("dialog’s transition")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("close-on-confirm")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.0")])]), _vm._v(" "), _c('td', [_vm._v("whether close automatically when confirm button is clicked")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("input-attrs")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.7")])]), _vm._v(" "), _c('td', [_vm._v("input attributes")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("mask-z-index")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")]), _c('br'), _c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("1000")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.4")])]), _vm._v(" "), _c('td', [_vm._v("zIndex of mask")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("body content of the dialog")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-cancel")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("triggers when the cancel button is clicked")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-confirm")])]), _vm._v(" "), _c('td', [_vm._v("(value)")]), _vm._v(" "), _c('td', [_vm._v("triggers when the confirm button is clicked")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-show")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("triggers when the dialog shows")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-hide")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("triggers when the dialog hides")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.4")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("[feature] support prop:mask-z-index")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("setInputValue")])]), _vm._v(" "), _c('td', [_vm._v("(value)")]), _vm._v(" "), _c('td', [_vm._v("set input value when show-input is true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.5")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/confirm"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/countdown/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/countdown"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/countdown",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Countdown.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Countdown } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("total sections")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("start")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if start counting down")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/countdown"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/countup/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/countup"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/countup",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Countup.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Countup } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("start-val")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("min number")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("end-val")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("max number")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("decimals")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("decimal length")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("duration")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("duration value (second)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("options")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("options for "), _c('code', [_vm._v("countup.js")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("start")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if start counting automatically")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("tag")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("span")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.5")])]), _vm._v(" "), _c('td', [_vm._v("render tag")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/countup"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/datetime-range/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/datetime-range"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/datetime-range",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/DatetimeRange.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { DatetimeRange } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("label text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("form’s value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding. For example, [‘2017-01-15’, ‘03’, ‘05’]")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("inline-desc")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("description of the cell")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("placeholder")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("placeholder, works when "), _c('code', [_vm._v("value")]), _vm._v(" is empty")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("start-date")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("start date (YYYY-MM-DD)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("end-date")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("end date (YYYY-MM-DD)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("format")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("YYYY-MM-DD")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("display format for date column")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value)")])]), _vm._v(" "), _c('td', [_vm._v("$emits when value changes, "), _c('code', [_vm._v("(newVal)")])]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/datetime-range"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/datetime-view/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/datetime-view"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/datetime-view",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/DatetimeView.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { DatetimeView } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("form’s value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("format")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("YYYY-MM-DD")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("display format for date column")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("render")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("re-render component")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.0")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/datetime-view"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/datetime/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/datetime"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/datetime",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Datetime.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Datetime } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("format")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("YYYY-MM-DD")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("date format. Special characters are not supported, for example, YYYY-MM-DD HH:mm:ss")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("cell title")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("form’s value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("inline-desc")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("description of the cell")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("placeholder")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("placeholder, works when value is empty")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("min-year")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("min-year of the form")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("max-year")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("max-year of the form")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("min-hour")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("min hour")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("max-hour")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("23")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("max hour")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("confirm-text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("ok(确认)")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("confirm button’s text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("cancel-text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("cancel(取消)")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("cancel button’s text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("clear-text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("custom button’s text which shows in the middle of the header")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("year-row")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("{value}")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("render template for the year column")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("month-row")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("{value}")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("render template for the month column")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("day-row")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("{value}")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("render template for the day column")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("hour-row")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("{value}")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("render template for the hour column")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("minute-row")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("{value}")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("render template for the minute column")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("start-date")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("start date, must be YYYY-MM-DD. Please use "), _c('code', [_vm._v("min-hour")]), _vm._v(" and "), _c('code', [_vm._v("max-hour")]), _vm._v(" to limit the range of hours")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("end-date")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("end date, must be YYYY-MM-DD. Please use "), _c('code', [_vm._v("min-hour")]), _vm._v(" and "), _c('code', [_vm._v("max-hour")]), _vm._v(" to limit the range of hours")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("required")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if required")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("display-format")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-function"
  }, [_vm._v("Function")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.11")])]), _vm._v(" "), _c('td', [_vm._v("used to format display value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("readonly")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.6")])]), _vm._v(" "), _c('td', [_vm._v("readonly mode, show like a cell")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.7")])]), _vm._v(" "), _c('td', [_vm._v("control visibility of datetime, require vue^2.3")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("minute-list")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.7")])]), _vm._v(" "), _c('td', [_vm._v("specify minute list, for instance [‘00’, ‘15’, ‘30’, ‘45’]")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("hour-list")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.7")])]), _vm._v(" "), _c('td', [_vm._v("specify hour list, for instance [‘09’, ‘10’, ‘11’, ‘12’]")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default-selected-value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.4.1")])]), _vm._v(" "), _c('td', [_vm._v("set default selected value, works only when value is empty")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("compute-hours-function")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-function"
  }, [_vm._v("Function")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.5")])]), _vm._v(" "), _c('td', [_vm._v("dynamically set hours list, params "), _c('code', [_vm._v("(value, isToday, generateRange)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("compute-days-function")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-function"
  }, [_vm._v("Function")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.1")])]), _vm._v(" "), _c('td', [_vm._v("dynamically set days list, params "), _c('code', [_vm._v("({year, month, min, max}, generateRange)")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("trigger element content")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_vm._v("title slot")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.6")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value)")])]), _vm._v(" "), _c('td', [_vm._v("$emits when value changes, "), _c('code', [_vm._v("(newVal)")])]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-clear")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("$emits when click the button in the middle of the header")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-show")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("fires when datetime shows")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-hide")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(type)")]), _vm._v(", type is one of [cancel, confirm]")]), _vm._v(" "), _c('td', [_vm._v("fires when datetime hides")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.7.4")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-cancel")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("fires when cancel button is clicked or mask is clicked")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.7.4")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-confirm")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("fires when confirm button is clicked")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.7.4")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/datetime"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/divider/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/divider"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/divider",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Divider.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Divider } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("title")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/divider"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/drawer/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/drawer"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/drawer",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Drawer.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Drawer } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.4.0")])]), _vm._v(" "), _c('td', [_vm._v("visibility of the component, use :show.sync to control the visibility(vue@^2.3.3)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("drawer-style")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.4.0")])]), _vm._v(" "), _c('td', [_vm._v("menu container styles")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-mode")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("overlay")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.4.0")])]), _vm._v(" "), _c('td', [_vm._v("animation type, can be push or overlay")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("placement")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("left")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.4.0")])]), _vm._v(" "), _c('td', [_vm._v("placement, left or right")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("page content container")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.4.0")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("drawer")])]), _vm._v(" "), _c('td', [_vm._v("drawer menu container")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.4.0")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/drawer"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/flexbox/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/flexbox"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/flexbox",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Flexbox.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Flexbox } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-component-name"
  }, [_vm._v("Flexbox")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("gutter")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("8")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("gap size (px)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("orient")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("horizontal")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("can be in [‘horizontal’, ‘vertical’]")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("justify")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_c('code', [_vm._v("justify-content")]), _vm._v(" in "), _c('code', [_vm._v("flex")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("align")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_c('code', [_vm._v("align-items")]), _vm._v(" in "), _c('code', [_vm._v("flex")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("wrap")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_c('code', [_vm._v("flex-wrap")]), _vm._v(" in "), _c('code', [_vm._v("flex")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("direction")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_c('code', [_vm._v("flex-direction")]), _vm._v(" in "), _c('code', [_vm._v("flex")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("content slot for "), _c('code', [_vm._v("flexbox-item")])]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-component-name"
  }, [_vm._v("FlexboxItem")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("span")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("occupied width. If not set, all flexbox-item will get the same width.")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("order")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_c('code', [_vm._v("order")]), _vm._v(" in "), _c('code', [_vm._v("flex")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("content slot")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/flexbox"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/flow/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/flow"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/flow",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Flow.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Flow } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-component-name"
  }, [_vm._v("Flow")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("orientation")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("horizontal")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("orientation of flow, can be in [‘horizontal’, ‘vertical’]")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-component-name"
  }, [_vm._v("FlowState")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("title for state point")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("state")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")]), _c('br'), _c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("content showed inside state point.")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("is-done")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if done")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_vm._v("title for state point，default content is prop:title")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.7.0")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-component-name"
  }, [_vm._v("FlowLine")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("tip")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("tip for flow line, invalid when is-done is true")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("tip-direction")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("top for horizontal flow, left for vertical flow")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("orientation of tip, can be in [‘top’, ‘right’, ‘bottom’, ‘left’]. If horizontal flow, the default is top; if vertical flow, the default is left")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("is-done")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if done")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("line-span")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")]), _c('br'), _c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("length of flow line. if not set, all flow-line will get the same length")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("process-span")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")]), _c('br'), _c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("50")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("percentage rate of progress which will be showed in flow line")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/flow"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/form-preview/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/form-preview"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/form-preview",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/FormPreview.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { FormPreview } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("header-label")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("header label")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("header-value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("header value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("body-items")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td', [_vm._v("[]")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("a list of label and value pair")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("footer-buttons")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td', [_vm._v("[]")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("button list. Default is a gray style, and the primary text is highlighted. [{style: ‘primary’, text: ‘text’, onButtonClick: fn(prop:name), link: ‘/path’}]")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/form-preview"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/grid/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/grid"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/grid",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Grid.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Grid, GridItem } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-component-name"
  }, [_vm._v("Grid")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("rows")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.0")])]), _vm._v(" "), _c('td', [_vm._v("(deprecated after v2.6.0) the number of rows. Less than 5 will be better")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("cols")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.1")])]), _vm._v(" "), _c('td', [_vm._v("the number of columns. if there is more than one row in grid, need to set cols value, otherwise all grid items will show in one row with the same width")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-lr-borders")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.8.1")])]), _vm._v(" "), _c('td', [_vm._v("whether show left and right borders")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-vertical-dividers")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.8.1")])]), _vm._v(" "), _c('td', [_vm._v("whether show vertical dividers")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("default slot for "), _c('code', [_vm._v("grid-item")]), _vm._v(" list")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-component-name"
  }, [_vm._v("GridItem")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("icon")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("icon url. if using local resources, it is better to use "), _c('code', [_vm._v("slot=icon")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("label")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_c('code', [_vm._v("label")]), _vm._v(" text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("link")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("vue-router’s path")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("icon")])]), _vm._v(" "), _c('td', [_vm._v("icon slot, use "), _c('code', [_vm._v("<img>")])]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("label")])]), _vm._v(" "), _c('td', [_vm._v("slot for label, the same func as prop:label")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/grid"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/group/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/group"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/group",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Group.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Group } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('code', [_vm._v("Group")]), _vm._v(" is a special component for wrapping form elements")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("group title")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title-color")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("group title’s color")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("label-width")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("common label width for child components")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("label-align")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("common label text-align for child components")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("label-margin-right")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("common margin right value for child components")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("gutter")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("set the marginTop value when there is no title")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("content body for child components")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_vm._v("title slot")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.1")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/group"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/icon/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/icon"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/icon",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Icon.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Icon } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("type")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("icon name, optional values are shown in demo")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("is-msg")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if used as msg icon. Icon’s font-size will be bigger(93px) than default")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/icon"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"success\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"info\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"info-circle\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"warn\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"waiting\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"waiting-circle\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"safe-success\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"safe-warn\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"success-circle\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"success-no-circle\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"circle\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"download\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"cancel\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"search\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"clear\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"success\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("is-msg")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"info\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("is-msg")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"safe-success\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("is-msg")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"safe-warn\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("is-msg")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("icon")]), _vm._v(">")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/inline-calendar/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/inline-calendar"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/inline-calendar",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/InlineCalendar.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { InlineCalendar } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")]), _c('br'), _c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("calendar value, use "), _c('code', [_vm._v("v-modle")]), _vm._v(" for binding. String (including empty) means single seleciton; array (including empty array) means multiple selection.")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("render-month")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("specify which date to render, for example [2018, 8]")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("start-date")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("start date with format "), _c('code', [_vm._v("YYYY-MM-dd")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("end-date")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("end date with format "), _c('code', [_vm._v("YYYY-MM-dd")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-last-month")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if show last month’s days")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-next-month")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if show next month’s days")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("highlight-weekend")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if highlight weekend days")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("return-six-rows")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if always show six rows")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("hide-header")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if hiding header")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("hide-week-list")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if hiding week list")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("replace-text-list")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("replace list, for example, {‘TODAY’:‘今’}")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("weeks-list")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td', [_vm._v("[‘Su’, ‘Mo’, ‘Tu’, ‘We’, ‘Th’, ‘Fr’, ‘Sa’]")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("week list, starting from "), _c('code', [_vm._v("Sunday")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("render-function")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-function"
  }, [_vm._v("Function")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("render function to add extra contents, params "), _c('code', [_vm._v("(line, row, dateData)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("render-on-value-change")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if re-render calendar if value changes, should set to false when showing multi months")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disable-past")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if disable the past days, can work with start-date")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disable-future")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if disable future days, can work with end-date")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("marks")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.0")])]), _vm._v(" "), _c('td', [_vm._v("(beta) style marks for specified date list")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disable-weekend")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.7.0")])]), _vm._v(" "), _c('td', [_vm._v("whether disable weekends")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disable-date-function")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-function"
  }, [_vm._v("Function")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.7.0")])]), _vm._v(" "), _c('td', [_vm._v("check if a date should be disabled")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("each-day")])]), _vm._v(" "), _c('td', [_vm._v("you can custom how to display each day")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.5")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when value is changed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-view-change")])]), _vm._v(" "), _c('td', [_vm._v("(data, index)")]), _vm._v(" "), _c('td', [_vm._v("fires when render month is changed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.12")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-select-single-date")])]), _vm._v(" "), _c('td', [_vm._v("(currentValue)")]), _vm._v(" "), _c('td', [_vm._v("fires when date is selected in radio mode")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("2.7.6")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("getDates")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("get current date list")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.11")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("switchViewToToday")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("render current month")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.12")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("switchViewToMonth")])]), _vm._v(" "), _c('td', [_vm._v("(year, month)")]), _vm._v(" "), _c('td', [_vm._v("render specified year and month")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.12")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("switchViewToCurrentValue")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("render with current value’s month")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.12")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/inline-calendar"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/inline-loading/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/inline-loading"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/inline-loading",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/InlineLoading.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { InlineLoading } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/inline-x-number/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/inline-x-number"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/inline-x-number",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/InlineXNumber.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { InlineXNumber } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("width")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("50px")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("width for number")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("button-style")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("square")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("button style, can be ‘round’")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("min")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("min value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("max")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("max value")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/inline-x-number"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/load-more/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/load-more"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/load-more",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/LoadMore.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { LoadMore } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-loading")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if show loading icon")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("tip")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("tip text. Show dot if there is no text and loading icon")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/load-more"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/loading/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/loading"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/loading",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Loading.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Loading } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("visibility of the component. Use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding before v2.5.7, otherwise use "), _c('code', [_vm._v(":show")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("loading text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("position")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("fixed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("position, default is "), _c('code', [_vm._v("fixed")]), _vm._v(", you can use "), _c('code', [_vm._v("absolute")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("transition")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("vux-mask")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("transition name")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("content area")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/loading"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/marquee/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/marquee"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/marquee",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Marquee.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Marquee, MarqueeItem } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-component-name"
  }, [_vm._v("Marquee")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("interval")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("2000")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("switch interval time")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("duration")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("300")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("animation time")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("direction")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("up")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("direction of animation, can be in [‘up’, ‘down’]")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("item-height")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("item height, set value if marquee initial state is hidden")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("container of marquee items")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-component-name"
  }, [_vm._v("MarqueeItem")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("content slot")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/marquee"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/masker/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/masker"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/masker",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Masker.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Masker } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("color")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("0, 0, 0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("the mask’s color in rgb format, for example, ‘0, 0, 0’")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("opacity")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0.5")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("the opacity of the mask")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("fullscreen")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.14")])]), _vm._v(" "), _c('td', [_vm._v("if masker is fullscreen")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("content below the mask")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("content")])]), _vm._v(" "), _c('td', [_vm._v("content above the mask")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/masker"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/msg/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/msg"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/msg",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Msg.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Msg } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("text to show operation status")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("description")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("description")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("icon")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("success")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("icon type. You can use "), _c('code', [_vm._v("success")]), _vm._v(", "), _c('code', [_vm._v("warn")]), _vm._v(", "), _c('code', [_vm._v("info")]), _vm._v(", "), _c('code', [_vm._v("waiting")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("buttons")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("buttons list. A button item includes "), _c('code', [_vm._v("text")]), _vm._v(", "), _c('code', [_vm._v("type")]), _vm._v("(the same as x-button type), "), _c('code', [_vm._v("link")]), _vm._v(", "), _c('code', [_vm._v("onClick")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("buttons")])]), _vm._v(" "), _c('td', [_vm._v("used for custom buttons")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("description")])]), _vm._v(" "), _c('td', [_vm._v("used for custom description")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/msg"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/panel/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/panel"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/panel",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Panel.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Panel } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("header")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("header title")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("footer")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("footer config, "), _c('code', [_vm._v("{url: url, title: title}")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("list")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("content list "), _c('code', [_vm._v("[{title, desc, src, fallbackSrc, meta:{source,date,other"), _c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_c('span', [_vm._v("}}")])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])]), _vm._v("]")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("type")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("one of ‘1’, ‘2’, ‘3’, ‘4’, ‘5’")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click-header")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when clicking header")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click-item")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(item)")])]), _vm._v(" "), _c('td', [_vm._v("emits when clicking item")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click-footer")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when clicking footer")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/panel"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/picker/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/picker"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/picker",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Picker.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Picker } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("picker value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("data")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("array list")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("columns")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("how many columns in chained-mode")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("fixed-columns")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("how many columns will show")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("column-width")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.0")])]), _vm._v(" "), _c('td', [_vm._v("custom width for each picker column, for example for a 3-column picker: [1/2, 1/5]")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value)")])]), _vm._v(" "), _c('td', [_vm._v("emits when value is changed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("getNameValues")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("get labels of current value")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.1")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/picker"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/popover/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/popover"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/popover",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Popover.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Popover } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("content")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("content of the popover")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("placement")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("position of the popover")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("gutter")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("the gutter between trigger element and popover arrow")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("trigger element")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("content")])]), _vm._v(" "), _c('td', [_vm._v("content of the popover")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-show")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("triggers when popover shows")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-hide")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("triggers when popover hides")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/popover"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/popup-header/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/popup-header"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/popup-header",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/PopupHeader.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { PopupHeader } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("left-text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.2")])]), _vm._v(" "), _c('td', [_vm._v("left text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("right-text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.2")])]), _vm._v(" "), _c('td', [_vm._v("right text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.2")])]), _vm._v(" "), _c('td', [_vm._v("title")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-bottom-border")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.2")])]), _vm._v(" "), _c('td', [_vm._v("whether show bottom border")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click-left")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when left text is clicked")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.2")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click-right")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when right text is clicked")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.2")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/popup-header"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/popup-picker/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/popup-picker"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/popup-picker",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/PopupPicker.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { PopupPicker } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("picker value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("label text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("cancel-text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("popup cancel text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("confirm-text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("popup confirm text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("placeholder")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("placeholder")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-name")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if show names instead of keys")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("inline-desc")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("description text below label")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("popup show (supports the .sync modifier next)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value-text-align")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("right")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.0-rc.3")])]), _vm._v(" "), _c('td', [_vm._v("value’s text align")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("display-format")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-function"
  }, [_vm._v("Function")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.7")])]), _vm._v(" "), _c('td', [_vm._v("used to format display text on cell, param: (currentValue)")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("popup-style")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.2")])]), _vm._v(" "), _c('td', [_vm._v("popup style")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("popup-title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.7.0")])]), _vm._v(" "), _c('td', [_vm._v("popup title")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_vm._v("title slot, use scope.labelClass and scope.labelStyle to inherit label styles")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.7")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value)")])]), _vm._v(" "), _c('td', [_vm._v("emits when value is changed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-show")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when popup shows")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-hide")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(closeType)")]), _vm._v(" true表示confirm(选择确认), false表示其他情况的关闭")]), _vm._v(" "), _c('td', [_vm._v("emits when popup is closed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-shadow-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(Array ids, Array names)")])]), _vm._v(" "), _c('td', [_vm._v("emits when picker value is changed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.6")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/popup-picker"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/popup-radio/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/popup-radio"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/popup-radio",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/PopupRadio.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { PopupRadio } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("readonly")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.6")])]), _vm._v(" "), _c('td', [_vm._v("readonly, shown like a cell")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("popup-header")])]), _vm._v(" "), _c('td', [_vm._v("popup header slot")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.3")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("each-item")])]), _vm._v(" "), _c('td', [_vm._v("custom how label displays")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.7")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-show")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("fires when popup shows")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.5")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-hide")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("fires when popup hides")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.5")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/popup-radio"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/popup/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/popup"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/popup",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Popup.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Popup } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("visibility of popup, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("height")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("auto")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("popup height, works when position is top or bottom")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("hide-on-blur")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if closing popup when mask being clicked")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("is-transparent")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.9")])]), _vm._v(" "), _c('td', [_vm._v("if using transparent background")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("width")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("auto")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.6")])]), _vm._v(" "), _c('td', [_vm._v("if you want to set 100% width, you should use this prop. only works when position is left or right")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("position")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("bottom")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.6")])]), _vm._v(" "), _c('td', [_vm._v("popup position, shoule be one of [‘left’, ‘right’, ‘top’, ‘bottom’]")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-mask")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.6")])]), _vm._v(" "), _c('td', [_vm._v("whether show mask")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("popup-style")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.2")])]), _vm._v(" "), _c('td', [_vm._v("popup style")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("hide-on-deactivated")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.5")])]), _vm._v(" "), _c('td', [_vm._v("whether hide popup on deactived event when using keep-alive")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("content body")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-hide")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when then popup is closed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-show")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when the popup shows")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-first-show")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits at the first time the popup shows")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/popup"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/previewer/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/previewer"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/previewer",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Previewer.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Previewer } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("[{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("msrc")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'https://placekitten.com/500/250'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("src")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'https://placekitten.com/800/400'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("w")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("600")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("h")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("400")]), _vm._v("\n},\n{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("src")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'https://placekitten.com/1200/900'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("msrc")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'https://placekitten.com/120/90'")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// thumbnail")]), _vm._v("\n  w: "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("1200")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("h")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("900")]), _vm._v("\n}]\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$refs.previewer.show(index)\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("list")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("images list")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("options")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("options for "), _c('code', [_vm._v("photoswipe")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("button-after")])]), _vm._v(" "), _c('td', [_vm._v("slot after control button list")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.3")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("button-before")])]), _vm._v(" "), _c('td', [_vm._v("slot before control button list")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.3")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-close")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("fires after closing")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.4")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-index-change")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("fires after index changes(shall not fire on first opening slide)")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.8.1")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("goTo")])]), _vm._v(" "), _c('td', [_vm._v("(index)")]), _vm._v(" "), _c('td', [_vm._v("go to specified image")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.10")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("prev")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("go to previous image")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.10")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.8.1")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("go to next image")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.10")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("getCurrentIndex")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("get current index")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.3")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/previewer"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/qrcode/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/qrcode"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/qrcode",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Qrcode.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Qrcode } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("content, make sure to prefix with http(s) when value is a link")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("size")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("80")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("size")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("bg-color")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type",
    staticStyle: {
      "width": "65px",
      "background-color": "#FFFFFF"
    }
  }, [_vm._v("#FFFFFF")])]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("background color")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("fg-color")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type",
    staticStyle: {
      "width": "65px",
      "background-color": "#000000"
    }
  }, [_vm._v("#000000")])]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("front color")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("type")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("img")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("render type, can be "), _c('code', [_vm._v("img")]), _vm._v(" or "), _c('code', [_vm._v("canvas")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/qrcode"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/radio/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/radio"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/radio",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Radio.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Radio } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("radio")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("title")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"title\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":options")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"options\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-model")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"value\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("radio")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group")]), _vm._v(">")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('code', [_vm._v("options")]), _vm._v(" can be plain array, or object list with key=> value:")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" options = [ "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'China'")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Japan'")]), _vm._v(" ]\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" options2 = [{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("icon")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'http://dn-placeholder.qbox.me/110x110/FF2D55/000'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("key")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'001'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("value")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'radio001'")]), _vm._v("\n}, {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("icon")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'http://dn-placeholder.qbox.me/110x110/FF2D55/000'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("key")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'002'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("value")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'radio002'")]), _vm._v("\n}]\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("radio value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("options")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("option list, can be plain array or array with "), _c('code', [_vm._v("key=>value")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("fill-mode")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if add an option user can fill")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("fill-placeholder")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("placeholder for fill input")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("fill-label")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("label for fill input")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.8")])]), _vm._v(" "), _c('td', [_vm._v("disable selecting")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("selected-label-style")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.4.0")])]), _vm._v(" "), _c('td', [_vm._v("set selected label style")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("each-item")])]), _vm._v(" "), _c('td', [_vm._v("custom how to display each item")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.5")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/radio"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/range/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/range"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/range",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Range.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Range } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("form value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("decimal")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if show decimals when value is changed")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("min")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("min number")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("max")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("100")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("max number")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("step")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("step value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if disabled")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("minHTML")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("custom html template for min value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("maxHTML")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("custom html template for max value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled-opacity")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("opacity value when is disabled")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("rangeBarHeight")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("range bar’s height")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value)")])]), _vm._v(" "), _c('td', [_vm._v("emits when value is changed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.2")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/range"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/rater/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/rater"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/rater",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Rater.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Rater } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("max")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("total star number")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("selected value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if disabled")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("star")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("★")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("start’s symbol text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("active-color")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type",
    staticStyle: {
      "width": "65px",
      "background-color": "#fc6"
    }
  }, [_vm._v("#fc6")])]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("symbol color when selected")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("margin")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("margin value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("font-size")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("25")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("font size")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("min")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.7.9")])]), _vm._v(" "), _c('td', [_vm._v("min value")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/rater"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/scroller/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/scroller"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/scroller",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Scroller.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Scroller } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("current pulldown and pullup status, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("height")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("viewport height")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("scroller’s height, you can use "), _c('code', [_vm._v("height=-40")]), _vm._v(" to make scroller set to height: "), _c('code', [_vm._v("viewportHeight - 40px")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("lock-x")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("lock the horizontal direction")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("lock-y")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("lock the vertical direction")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("scrollbar-x")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if show horizontal scrollbar")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("scrollbarY")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if show vertical scrollerbar")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("bounce")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if use bounce effect")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("use-pulldown")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if use pulldown plugin")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("use-pullup")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if use pullup plugin")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("pulldown-config")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td', [_vm._v("see below")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("config for pulldown plugin")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("pullup-config")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td', [_vm._v("see below")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("config for pullup plugin")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("scroll-bottom-offset")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.6")])]), _vm._v(" "), _c('td', [_vm._v("where to emit event:on-scroll-bottom before reaching bottom")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("scroller content, should has only one "), _c('code', [_vm._v("div")]), _vm._v(" root")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-scroll")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(position)")])]), _vm._v(" "), _c('td', [_vm._v("emits when user scrolls")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-scroll-bottom")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when user scrolls to bottom. The event may emit multiple times, so you should use a variable for keeping status if you need fetching data")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.6")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-pulldown-loading")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when scroller is on pulldown-loading status")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-pullup-loading")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when scroller is on pullup-loading status")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("reset")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(position, duration, easing)")])]), _vm._v(" "), _c('td', [_vm._v("reset scroller to reset height whenever your data is changed. easing can be one of ease-in, ease-in-out, ease, bezier(n, n, n, n)")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("donePullup")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("set pullup done after new data is fetched")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disablePullup")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("disable pullup plugin when there is no more data")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("enablePullup")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("enable pullup plugin")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("donePulldown")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("set pulldown done after new data is fetched")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/scroller"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("content")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Pull Down To Refresh'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("height")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("60")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("autoRefresh")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("false")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("downContent")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Pull Down To Refresh'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("upContent")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Release To Refresh'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("loadingContent")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Loading...'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("clsPrefix")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'xs-plugin-pulldown-'")]), _vm._v("\n}\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("content")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Pull Up To Refresh'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("pullUpHeight")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("60")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("height")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("40")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("autoRefresh")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("false")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("downContent")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Release To Refresh'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("upContent")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Pull Up To Refresh'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("loadingContent")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Loading...'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("clsPrefix")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'xs-plugin-pullup-'")]), _vm._v("\n}\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-qa"
  }, [_vm._v("QA 如何更新数据")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("如果展示内容只是简单的增加或者减少，直接调用"), _c('code', [_vm._v("reset")]), _vm._v("方法即可")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$nextTick("), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("()")]), _vm._v(" =>")]), _vm._v(" {\n  "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$refs.scroller.reset()\n})\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$nextTick("), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("()")]), _vm._v(" =>")]), _vm._v(" {\n  "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$refs.scroller.reset({\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("top")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("0")]), _vm._v("\n  })\n})\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-qa"
  }, [_vm._v("QA 如何设置pullup完成")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("方法1，直接调用ref的"), _c('code', [_vm._v("donePullup")]), _vm._v("方法")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$refs.demo2.donePullup()\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("scroller")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-model")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"status\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("scroller")]), _vm._v(">")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("data () {\n  "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("return")]), _vm._v(" {\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("status")]), _vm._v(": {\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("pullupStatus")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'default'")]), _vm._v("\n    }\n  }\n}\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("// 重置状态为default\nthis.status.pullupStatus = 'default\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-qa"
  }, [_vm._v("QA 如何设置pulldown完成")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("参照"), _c('code', [_vm._v("pullup")]), _vm._v(", 使用方法"), _c('code', [_vm._v("donePulldown")]), _vm._v("或者绑定"), _c('code', [_vm._v("pulldownStatus")]), _vm._v("然后重置为"), _c('code', [_vm._v("default")]), _vm._v("。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-qa"
  }, [_vm._v("QA 如何禁用或者启用pullup")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("在有些情况下，比如数据不多不需要上拉加载或者已经加载完成，我们需要禁用pullup"), _c('br'), _vm._v("\n同样可以调用方法 "), _c('code', [_vm._v("disablePullup")]), _vm._v(" 或者设置"), _c('code', [_vm._v("pullupStatus")]), _vm._v("为"), _c('code', [_vm._v("disabled")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("反之，则调用方法 "), _c('code', [_vm._v("enablePullup")]), _vm._v(" 或者设置"), _c('code', [_vm._v("pullupStatus")]), _vm._v("为"), _c('code', [_vm._v("enabled")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-qa"
  }, [_vm._v("启用keep-alive后滚动有问题")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("需要在调用Scroller的页面上在 hook: "), _c('code', [_vm._v("activated")]), _vm._v("上执行"), _c('code', [_vm._v("reset")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("activated () {\n  "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$refs.scroller.reset()\n}\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/search/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/search"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/search",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Search.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Search } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("placeholder")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("搜索(search)")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("placeholder text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("cancel-text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("取消(cancel)")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("cancel text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("input value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("results")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("search results, [{title: ‘hello’, otherData: otherValue}], will not show when auto-fixed is false")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("auto-fixed")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if auto fixed on top when input gets focus")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("top")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("0px")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("top value when fixed on top")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("position")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("fixed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("position value when pin the component on the top, one of "), _c('code', [_vm._v("fixed")]), _vm._v(", "), _c('code', [_vm._v("absolute")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("auto-scroll-to-top")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if auto scroll to top when input gets focus")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("slot above search result")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("right")])]), _vm._v(" "), _c('td', [_vm._v("slot on the right of input")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("left")])]), _vm._v(" "), _c('td', [_vm._v("slot on the left of input")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.5")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-submit")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value)")])]), _vm._v(" "), _c('td', [_vm._v("emits when form is submitted")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-cancel")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when cancel button is clicked")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value)")])]), _vm._v(" "), _c('td', [_vm._v("emits when value is changed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-result-click")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(item)")])]), _vm._v(" "), _c('td', [_vm._v("emits when result item is clicked")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-focus")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("when input gets focus")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.10")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-blur")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("fires when input losts focus")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.3")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("setFocus")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("set focus on input. you should call this method in a click event’s callback function on Safari")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("setBlur")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("make input lost focus")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.6")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/search"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/selector/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/selector"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/selector",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Selector.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Selector } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")]), _c('br'), _c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")]), _c('br'), _c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("form value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("label text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("direction")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("align value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("options")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("option list, "), _c('code', [_vm._v("['one', 'two']")]), _vm._v(" or "), _c('code', [_vm._v("[{ key: KEY, value: VALUE }]")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("name")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("form name")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("placeholder")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("placeholder")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("readonly")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if the select is readonly")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value-map")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.7.2")])]), _vm._v(" "), _c('td', [_vm._v("set a [value, label] pair for automatically transforming API data")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value)")])]), _vm._v(" "), _c('td', [_vm._v("emits when value is changed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("getFullValue")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("get full value including all the props(if option items are object)")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.7.2")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/selector"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/spinner/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/spinner"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/spinner",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Spinner.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Spinner } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("type")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("ios")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("icon type")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/spinner"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/step/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/step"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/step",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Step.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Step } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/step"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/sticky/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/sticky"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/sticky",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Sticky.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Sticky } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("scroll-box")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("window")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("scroll tagget")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("check-sticky-support")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if check if sticky is supported on current browser")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("offset")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("top distance")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("content")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("bindSticky")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("manually re-bind sticky")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.4")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/sticky"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/swipeout/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/swipeout"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/swipeout",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Swipeout.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-component-name"
  }, [_vm._v("Swipeout")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-component-name"
  }, [_vm._v("SwipeoutItem")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("sensitivity")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("undefined")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("auto-close-on-button-click")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("undefined")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("undefined")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("threshold")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0.3")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("undefined")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("transition-mode")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("reveal")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("undefined")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("left-menu")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("right-menu")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-open")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-close")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("open")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(direction)")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("close")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-component-name"
  }, [_vm._v("SwipeoutButton")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("undefined")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("background-color")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("undefined")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("type")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("undefined")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("width")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("80")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("undefined")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/swipeout"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/swiper/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/swiper"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/swiper",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Swiper.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Swiper } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("list")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("image list")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("direction")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("horizontal")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("swiping direction")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-dots")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if show indicators")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-desc-mask")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if show description mask")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("dots-position")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("right")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("indicator position")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("dots-class")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("custom indicator’s classname")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("auto")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if auto playing")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("loop")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if use loop mode")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("interval")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("3000")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("interval value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("threshold")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("50")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("threshold value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("duration")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("300")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("transition duration")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("height")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("180px")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("height value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("aspect-ratio")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if specified, height will be caculated automatically")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("min-moving-distance")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("min distance before moving")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("v-model")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("index value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-index-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(currentIndex)")])]), _vm._v(" "), _c('td', [_vm._v("fires when index is changed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-get-height")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(height)")])]), _vm._v(" "), _c('td', [_vm._v("fires after height is caculated")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.7.0")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/swiper"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/tab/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/tab"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/tab",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Tab.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Tab, TabItem } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-component-name"
  }, [_vm._v("Tab")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("line-width")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("undefined")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("active-color")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("undefined")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default-color")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("undefined")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled-color")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("undefined")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("bar-active-color")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("undefined")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("animate")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("undefined")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("custom-bar-width")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")]), _c('br'), _c('span', {
    staticClass: "type type-function"
  }, [_vm._v("Function")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.7")])]), _vm._v(" "), _c('td', [_vm._v("set active bar width, like "), _c('code', [_vm._v("50px")]), _vm._v(". or you can use function, param is "), _c('code', [_vm._v("(currentInex)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("badge-label")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.5")])]), _vm._v(" "), _c('td', [_vm._v("badge label")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("badge-background")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("null")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.5")])]), _vm._v(" "), _c('td', [_vm._v("badge background color")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("badge-color")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("null")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.5")])]), _vm._v(" "), _c('td', [_vm._v("badge font color")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("prevent-default")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.7.2")])]), _vm._v(" "), _c('td', [_vm._v("whether prevent auto-switching tab-item when tab-item is clicked")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("scroll-threshold")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.8.1")])]), _vm._v(" "), _c('td', [_vm._v("scroll tabs threshold")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-component-name"
  }, [_vm._v("TabItem")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("undefined")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("active-class")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("undefined")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-item-click")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(index)")])]), _vm._v(" "), _c('td', [_vm._v("emits when current tabItem is clicked")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.4")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/tab"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/tabbar/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/tabbar"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/tabbar",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Tabbar.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Tabbar, TabbarItem } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-component-name"
  }, [_vm._v("Tabbar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("icon-class")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("icon’s classname")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("slot for tabbar items")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-index-change")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when value is changed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.4")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-component-name"
  }, [_vm._v("TabbarItem")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("selected")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if selected, you can also use "), _c('code', [_vm._v("v-model=\"index\"")]), _vm._v(" on tabbar to set item selected")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("badge")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("badge text, if not specified, the badge will not show")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-dot")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if show the red dot")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("link")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("the url for current tabbar item, can be a url or a "), _c('code', [_vm._v("vue-router")]), _vm._v(" link value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("icon-class")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("the classname for current icon, if tabbar and tabbar-item both specify icon-class, tabbar-item’s will be usePulldown")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("icon")])]), _vm._v(" "), _c('td', [_vm._v("icon area")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("icon-active")])]), _vm._v(" "), _c('td', [_vm._v("will show when current item is activated")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.8")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("label")])]), _vm._v(" "), _c('td', [_vm._v("label text")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-item-click")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when tabbar item is clicked")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/tabbar"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/timeline/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/timeline"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/timeline",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Timeline.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Timeline, TimelineItem } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/toast/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/toast"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/toast",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Toast.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Toast } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if showing toast, use v-model for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("time")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("2000")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("show time")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("type")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("success")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("toast type, success, warn, cancel, text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("width")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("7.6em")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("toast’s width")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("is-show-mask")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if showing mask, users cannot operate other elements on the page")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("content of the toast, text or html, the same function as default slot")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("position")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("default")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.4")])]), _vm._v(" "), _c('td', [_vm._v("toast position, available values: default, top, middle, bottom")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("default slot, the content of the toast")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-show")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when toast shows")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-hide")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when toast hides")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/toast"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/view-box/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/view-box"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/view-box",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/ViewBox.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { ViewBox } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("body-padding-top")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("undefined")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("body-padding-bottom")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("undefined")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("header")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("bottom")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("scrollTo")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(top)")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("getScrollTop")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("getScrollBody")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/view-box"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/wechat-emotion/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/wechat-emotion"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/wechat-emotion",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/WechatEmotion.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { WechatEmotion } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("isGif")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if using gif image")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("emotion name, list: ‘微笑’, ‘撇嘴’, ‘色’, ‘发呆’, ‘得意’, ‘流泪’, ‘害羞’, ‘闭嘴’, ‘睡’, ‘大哭’, ‘尴尬’, ‘发怒’, ‘调皮’, ‘呲牙’, ‘惊讶’, ‘难过’, ‘酷’, ‘冷汗’, ‘抓狂’, ‘吐’, ‘偷笑’, ‘可爱’, ‘白眼’, ‘傲慢’, ‘饥饿’, ‘困’, ‘惊恐’, ‘流汗’, ‘憨笑’, ‘大兵’, ‘奋斗’, ‘咒骂’, ‘疑问’, ‘嘘’, ‘晕’, ‘折磨’, ‘衰’, ‘骷髅’, ‘敲打’, ‘再见’, ‘擦汗’, ‘抠鼻’, ‘鼓掌’, ‘糗大了’, ‘坏笑’, ‘左哼哼’, ‘右哼哼’, ‘哈欠’, ‘鄙视’, ‘委屈’, ‘快哭了’, ‘阴险’, ‘亲亲’, ‘吓’, ‘可怜’, ‘菜刀’, ‘西瓜’, ‘啤酒’, ‘篮球’, ‘乒乓’, ‘咖啡’, ‘饭’, ‘猪头’, ‘玫瑰’, ‘凋谢’, ‘示爱’, ‘爱心’, ‘心碎’, ‘蛋糕’, ‘闪电’, ‘炸弹’, ‘刀’, ‘足球’, ‘瓢虫’, ‘便便’, ‘月亮’, ‘太阳’, ‘礼物’, ‘拥抱’, ‘强’, ‘弱’, ‘握手’, ‘胜利’, ‘抱拳’, ‘勾引’, ‘拳头’, ‘差劲’, ‘爱你’, ‘NO’, ‘OK’, ‘爱情’, ‘飞吻’, ‘跳跳’, ‘发抖’, ‘怄火’, ‘转圈’, ‘磕头’, ‘回头’, ‘跳绳’, ‘挥手’, ‘激动’, ‘街舞’, ‘献吻’, ‘左太极’, ‘右太极’")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/wechat-emotion"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/x-address/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-address"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/x-address",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/XAddress.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-address")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("title")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"title\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-model")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"value\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-address")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group")]), _vm._v(">")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XAddress } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// you can import built-in data")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XAddress, ChinaAddressV3Data } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// if you need older data")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XAddress, ChinaAddressV1Data } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("raw-value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if the initial value is "), _c('code', [_vm._v("string value")]), _vm._v(" instead of "), _c('code', [_vm._v("id value")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("label text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("form value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("list")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("address data")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("inline-desc")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("description text below label")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("placeholder")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("placeholder")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("hide-district")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if hide district column")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value-text-align")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("right")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("align setting of "), _c('code', [_vm._v("value")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("popup-style")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.2")])]), _vm._v(" "), _c('td', [_vm._v("popup style")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.8")])]), _vm._v(" "), _c('td', [_vm._v("popup show (supports the .sync modifier next)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_vm._v("title slot")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.8")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-hide")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when being closed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-show")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when being open")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-shadow-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(Array ids, Array names)")])]), _vm._v(" "), _c('td', [_vm._v("emits when picker value is changed")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.6")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-address"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/x-button/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-button"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/x-button",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/XButton.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XButton } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("type")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("default")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("button style type, one of default, primary, warn")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if disable the button")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("text")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("button text, has the same function as default slot")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("mini")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if use smaller style")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("plain")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if use plain styles which has no backgroundColor")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("action-type")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("button’s type value, one of "), _c('code', [_vm._v("submit")]), _vm._v(", "), _c('code', [_vm._v("button")]), _vm._v(", "), _c('code', [_vm._v("reset")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("link")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.3.5")])]), _vm._v(" "), _c('td', [_vm._v("vue-router path, "), _c('code', [_vm._v("BACK")]), _vm._v(" is alias to "), _c('code', [_vm._v("go(-1)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-loading")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("show loading icon")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("gradients")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.7.4")])]), _vm._v(" "), _c('td', [_vm._v("iOS design gradients, Array length should be 2")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("button text")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-button"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/x-circle/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-circle"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/x-circle",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/XCircle.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XCircle } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("stroke-width")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("top line’s width")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("stroke-color")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type",
    staticStyle: {
      "width": "65px",
      "background-color": "#3FC7FA"
    }
  }, [_vm._v("#3FC7FA")])]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("top line’s color")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("trail-width")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("bottom line’s width")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("trail-color")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type",
    staticStyle: {
      "width": "65px",
      "background-color": "#D9D9D9"
    }
  }, [_vm._v("#D9D9D9")])]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("bottom line’s color")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("percent")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("percentage value")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-circle"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/x-dialog/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-dialog"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/x-dialog",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/XDialog.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XDialog } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "warning"
  }, [_vm._v("\nif you use `XDialog` inside `ViewBox` or use `overflowScrolling:touch`，please should import `directive:transfer-dom` to fix `z-index` invalid issue。\n"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\notherwise, you don't need to use `v-transfer-dom`.\n")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { TransferDomDirective "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("as")]), _vm._v(" TransferDom } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("default")]), _vm._v(" {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("directives")]), _vm._v(": {\n    TransferDom\n  }\n}\n\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-transfer-dom")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-dialog")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-dialog")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("visibility of the dialog, supports the .sync modifier")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("mask-transition")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("vux-mask")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("transition of mask")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("dialog-transition")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("vux-dialog")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("transition of dialog body")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("hide-on-blur")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if closing dialog when clicking on mask")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("scroll")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("[deprecated]if body content can scroll when scrolling on dialog")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("dialog-style")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.2")])]), _vm._v(" "), _c('td', [_vm._v("set dialog styles, you can use it for overwritting default width and background style")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("mask-z-index")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")]), _c('br'), _c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("1000")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.4")])]), _vm._v(" "), _c('td', [_vm._v("zIndex of mask")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("main content of the dialog")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-show")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when opening dialog")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-hide")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("emits when closing dialog")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-dialog"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/x-header/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-header"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/x-header",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/XHeader.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XHeader } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("left-options.showBack")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if show back text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("left-options.backText")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("Back")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("the back text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("left-options.preventGoBack")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("stop go back when clicking")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("title")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("transition")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("title transition")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("right-options.showMore")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if show more icon")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("title")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("left")])]), _vm._v(" "), _c('td', [_vm._v("left slot after backText")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("overwrite-left")])]), _vm._v(" "), _c('td', [_vm._v("overwrite left icon and text")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.2")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("right")])]), _vm._v(" "), _c('td', [_vm._v("right slot")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("overwrite-title")])]), _vm._v(" "), _c('td', [_vm._v("overwrite title content")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.3")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click-more")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("triggers when more icon is clicked")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click-back")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("triggers when left part is clicked and the prop ‘left-options.preventGoBack’ is true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click-title")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("triggers when title is clicked")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-header"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/x-icon/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-icon"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/x-icon",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/XIcon.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('code', [_vm._v("x-icon")]), _vm._v(" is a virtual component，which means you don’t need to import "), _c('code', [_vm._v("XIcon")]), _vm._v(", "), _c('code', [_vm._v("vux-loader@^1.0.46")]), _vm._v(" will transform your code into "), _c('code', [_vm._v("inline svg")]), _vm._v("。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("you can set "), _c('code', [_vm._v("fill")]), _vm._v(" style by its class names.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Currently it does not support "), _c('code', [_vm._v("svg sprite")]), _vm._v("，will implement in later release.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-icon")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"ios-arrow-up\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-icon")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-icon")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"ios-arrow-up\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("size")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"30\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-icon")]), _vm._v(">")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("type")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("icon name")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("size")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("24")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("icon size")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-icon"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/x-img/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-img"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/x-img",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/XImg.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XImg } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default-src")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("default image src")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("src")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("real image src")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("webp-src")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("real image src in webp format, if current browser supports webp, this image will be loaded")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("error-class")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("a class name will be added to the img element if loading failed")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("success-class")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("a class name will be added to the img element if loading successfully")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("offset")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("100")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("how early you want the elements to be loaded before they’re visible")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("container")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("window")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("If you want to lazy load elements inside a scrolling container change the default value to the selector of the container")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("delay")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("delay execute lazyload function because sometimes transition between routes will cause problems")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-img"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/x-input/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-input"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/x-input",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/XInput.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XInput } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("input value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("type")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("text")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("input type, one of "), _c('code', [_vm._v("text")]), _vm._v(","), _c('code', [_vm._v("number")]), _vm._v(","), _c('code', [_vm._v("email")]), _vm._v(","), _c('code', [_vm._v("password")]), _vm._v(","), _c('code', [_vm._v("tel")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("is-type")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")]), _c('br'), _c('span', {
    staticClass: "type type-function"
  }, [_vm._v("Function")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("custom validating function, should return "), _c('code', [_vm._v("{valid:true}")]), _vm._v(" or "), _c('code', [_vm._v("{valid:false, msg: error msg}")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("required")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if is required")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("label text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("placeholder")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("placeholder")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-clear")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if show clear icon")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("min")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("minlength for input")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("max")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("maxlength for input")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if input is disabled")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("readonly")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if input is readonly")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("debounce")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("debounce time")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("placeholder-align")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("left")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.8")])]), _vm._v(" "), _c('td', [_vm._v("placeholder align value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("text-align")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("left")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("text-align setting for value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("label-width")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.4")])]), _vm._v(" "), _c('td', [_vm._v("set label width which will not be overwritten by $parent.labelWidth")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("mask")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.1")])]), _vm._v(" "), _c('td', [_vm._v("(beta) value mask, 9 for DIGIT, A for ALPHA, S for ALPHA AND DIGIT")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("should-toast-error")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.3")])]), _vm._v(" "), _c('td', [_vm._v("whether toast error when clicking on error icon")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("label")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("restricted-label")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("right")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("right-full-height")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.8.1")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-blur")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value, $event)")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-focus")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value, $event)")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-enter")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value, $event)")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value)")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click-error-icon")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(error)")])]), _vm._v(" "), _c('td', [_vm._v("fires when clicking error icon")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.3")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("focus")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("get input focus")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("blur")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("remove focus from input")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("reset")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value = '')")])]), _vm._v(" "), _c('td', [_vm._v("reset input value and clear errors")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.10")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-input"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/x-number/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-number"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/x-number",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/XNumber.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XNumber } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-number")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("title")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"title\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-model")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"value\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-number")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group")]), _vm._v(">")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("form value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("label text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("min")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("minimum number of value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("max")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("maximum number of value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("step")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("step value")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("fillable")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if use can fill the number")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("width")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("50px")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("width of the input element")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("button-style")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("square")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("button styles, [‘square’, ‘round’]")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("align")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("right")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("align setting of the selecting area")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-number"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/x-progress/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-progress"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/x-progress",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/XProgress.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XProgress } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("percent")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("percent of the progress, 0-100")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-cancel")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if show the cancel button")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-cancel")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("triggers when the cancel button is clicked")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-progress"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/x-switch/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-switch"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/x-switch",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/XSwitch.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XSwitch } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-switch")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("title")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"title\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-model")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"value\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-switch")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group")]), _vm._v(">")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("label text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if disabled")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("component’s value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("inline-desc")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("desctiption text below the label")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("prevent-default")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.0")])]), _vm._v(" "), _c('td', [_vm._v("prevent from setting value on being clicked")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value-map")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-array"
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td', [_vm._v("[false, true]")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.7.0")])]), _vm._v(" "), _c('td', [_vm._v("customize not-boolean values")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value)")])]), _vm._v(" "), _c('td', [_vm._v("triggers when value change, params is (currentValue)")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(newVal, oldVal)")])]), _vm._v(" "), _c('td', [_vm._v("triggers when being clicked")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-switch"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/x-table/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-table"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/x-table",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/XTable.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XTable } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("full-bordered")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.4")])]), _vm._v(" "), _c('td', [_vm._v("if show left and right border of the table")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("content-bordered")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.4")])]), _vm._v(" "), _c('td', [_vm._v("if show body tr’s bottom border")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("cell-bordered")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.4")])]), _vm._v(" "), _c('td', [_vm._v("if show the right border of ths and tds")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("table content")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.4")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-table"
    }
  }, [_vm._v("Demo page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/x-textarea/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("Edit document")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-textarea"
    }
  }, [_vm._v("Demo page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/x-textarea",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/XTextarea.vue",
      "target": "_blank"
    }
  }, [_vm._v("Demo source")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XTextarea } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.8")])]), _vm._v(" "), _c('td', [_vm._v("label text")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("inline-desc")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.8")])]), _vm._v(" "), _c('td', [_vm._v("description text below title")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-counter")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("if show the text length counter")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("max")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("maxlength limit")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("textarea’s value, use "), _c('code', [_vm._v("v-model")]), _vm._v(" for binding")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("name")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("textarea’s name")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("placeholder")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("placeholder")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("rows")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("textarea’s rows attribute")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("cols")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("30")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("textarea’s cols attribute")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("height")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("height")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("readonly")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("textarea’s readonly attribute")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disabled")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("textarea’s disabled attribute")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("autosize")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.6")])]), _vm._v(" "), _c('td', [_vm._v("whether set auto height for textarea")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("label")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.8")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("restricted-label")])]), _vm._v(" "), _c('td', [_vm._v("undefined")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.8")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-change")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(value)")])]), _vm._v(" "), _c('td', [_vm._v("triggers when value changes")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-focus")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("focus event")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.11")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-blur")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("blur event")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.1.1-rc.11")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("updateAutosize")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("reset autosize, if value is not empty initially, you should call this function to update size")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.1")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-textarea"
    }
  }, [_vm._v("Demo page")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1a3e5584", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-1a3e5584"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/components-27.vue
// module id = 2515
// module chunks = 587